import { useEffect, useState } from "react"

export const useServerState = <T>(value: T) => {
  const [state, setState] = useState(value)
  useEffect(() => { setState(value) }, [value])
  return [state, setState] as const
}
